import SpinnerLoader from '@/components/Common/header/spinner-loader'
import { vyaparApiBaseUrl } from '@/root/api/apiConstants'
import { fetchRequest } from '@/root/utils/network-adapter/fetch-request'
import Modal from '@/stories/components/Common/Modal'
import Cookies from 'js-cookie'
import { useQuery } from 'react-query'
import PrettyBlueButton from '../PrettyBlueButton'
import { StencilCDNImage } from '@/components/Common/StencilImage'

export interface TConvertToDeliveryStatusData {
  stock_name?: string
  conversion_row?: ConversionRow
}

export interface ConversionRow {
  ID?: number
  requested_qty?: number
  qty?: number
}

export default function ConvertToDeliveryStatus({ showModal, onClose, id }) {
  const token = Cookies.get('token')
  const { isLoading, isError, data } = useQuery<TConvertToDeliveryStatusData>(
    ['convert-to-delivery-status', id],
    () => {
      return fetchRequest({
        url: `${vyaparApiBaseUrl}/api/v1/mis/positions/convert/status?response_format=rest&conv_id=${id}`,
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
            Platform: 'web',
          },
        },
      })
    },
  )

  if (isLoading) {
    return (
      <Modal showModal={showModal} bodyClassName="max-w-[400px]">
        <div className="p-5">
          <SpinnerLoader />
        </div>
      </Modal>
    )
  } else if (isError) {
    return (
      <Modal showModal={showModal} bodyClassName="max-w-[400px]">
        <div className="flex w-full flex-col items-center justify-center p-5 text-sm">
          <span className="mb-5 text-center">
            Something went wrong while converting your intraday position to
            delivery
          </span>
          <PrettyBlueButton text="Go back" onClick={onClose} />
        </div>
      </Modal>
    )
  }

  return (
    <Modal showModal={showModal} bodyClassName="max-w-[400px]">
      <div className="flex flex-col items-center justify-center gap-2 p-5">
        {(data?.conversion_row?.qty ?? 0) > 0 ? (
          <>
            <StencilCDNImage
              src="https://indcdn.indmoney.com/cdn/images/fe/green-tick-icon.png"
              width={60}
              height={60}
            />{' '}
            <p className="text-center text-lg font-medium">
              Intraday positions converted to delivery
            </p>
            <p className="text-center">{data?.stock_name}</p>
            <div className="flex w-full justify-between text-sm">
              <span>Qty</span>
              <span>
                {data?.conversion_row?.qty} /{' '}
                {data?.conversion_row?.requested_qty}
              </span>
            </div>
            <button
              className="bg-brand-green-dark text-brand-white mt-2 w-3/4 self-center rounded-full py-2 "
              onClick={() => {
                window.location.reload()
              }}
            >
              Continue
            </button>
          </>
        ) : (
          <>
            {' '}
            <StencilCDNImage
              src="https://indcdn.indmoney.com/cdn/images/fe/wrong-red.png"
              width={60}
              height={60}
            />
            <p className="text-center text-lg font-medium">
              Intraday positions failed to convert to delivery
            </p>
            <button
              className="bg-brand-green-dark text-brand-white mt-2 w-3/4 self-center rounded-full py-2 "
              onClick={() => {
                window.location.reload()
              }}
            >
              Continue
            </button>
          </>
        )}
      </div>
    </Modal>
  )
}
